module.exports = __webpack_public_path__ + "img/appCode.88073311.png";